module.exports = __webpack_public_path__ + "static/media/roboto-v27-latin-regular.9293bc52.ttf";